export const Carousel = {
  Navigation: {
    NEXT: "Далі",
    PREVIOUS: "Назад",
  },
};
